// @ts-nocheck
class HeroBannerSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector('.hero-banner-slider__swiper');
    if (!swiperEl) return;

    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || '5000', 10);
    const showPagination = this.dataset.showPagination === 'true';

    const config = {
      slidesPerView: 1,
      loop: false,
      autoplay: {
        delay: autoplaySpeed,
        disableOnInteraction: false,
      },
      speed: 800,
      on: {
        init: (swiper) => {
          this.updateNumberPagination(swiper);
          this.updateProgressBar(swiper);
          this.updateArrowState(swiper);
          this.updatePaginationColor(swiper);
        },
        slideChange: (swiper) => {
          this.updateNumberPagination(swiper);
          this.updateArrowState(swiper);
          this.updatePaginationColor(swiper);
        },
        autoplayTimeLeft: (_swiper, _timeLeft, percentage) => {
          this.updateProgressBar(null, 1 - percentage);
        },
      },
    };

    if (showPagination) {
      config.pagination = {
        el: swiperEl.querySelector('.hero-banner-slider__dots'),
        clickable: true,
        bulletClass: 'hero-banner-slider__dot',
        bulletActiveClass: 'hero-banner-slider__dot--active',
      };
    }

    this.swiperInstance = new Swiper(swiperEl, config);

    // Number pagination click handlers
    const numberItems = this.querySelectorAll('.hero-banner-slider__number-item');
    numberItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (this.swiperInstance) {
          this.swiperInstance.slideToLoop(index);
        }
      });
    });

    // Mobile arrow click handlers
    const prevArrow = this.querySelector('.hero-banner-slider__arrow--prev');
    const nextArrow = this.querySelector('.hero-banner-slider__arrow--next');

    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        if (this.swiperInstance) this.swiperInstance.slidePrev();
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        if (this.swiperInstance) this.swiperInstance.slideNext();
      });
    }
  }

  updateNumberPagination(swiper) {
    const realIndex = swiper.realIndex;
    const numberItems = this.querySelectorAll('.hero-banner-slider__number-item');

    numberItems.forEach((item, index) => {
      item.classList.toggle('hero-banner-slider__number-item--active', index === realIndex);
    });
  }

  updatePaginationColor(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const btnColor = activeSlide.dataset.btnColor || 'white';
    const activeItems = this.querySelectorAll('.hero-banner-slider__number-item--active');
    const allItems = this.querySelectorAll('.hero-banner-slider__number-item');

    // active number color matches button color
    const activeColor = btnColor === 'white' ? '#fff' : '#090909';

    allItems.forEach((item) => {
      item.style.color = '';
    });

    activeItems.forEach((item) => {
      item.style.color = activeColor;
    });
  }

  updateArrowState(swiper) {
    const prevArrow = this.querySelector('.hero-banner-slider__arrow--prev');
    const nextArrow = this.querySelector('.hero-banner-slider__arrow--next');
    if (!prevArrow || !nextArrow) return;

    prevArrow.disabled = swiper.isBeginning;
    nextArrow.disabled = swiper.isEnd;
  }

  updateProgressBar(swiper, progress) {
    const progressBar = this.querySelector('.hero-banner-slider__progress-fill');
    if (!progressBar) return;

    if (swiper) {
      progressBar.style.width = '0%';
    } else if (progress !== undefined) {
      progressBar.style.width = `${progress * 100}%`;
    }
  }
}

if (!customElements.get('hero-banner-slider')) {
  customElements.define('hero-banner-slider', HeroBannerSlider);
}
